import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

export const fetchData = createAsyncThunk(
  'data/fetchData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(API_ROUTES.Gachas)
      return response.data.gachas || []
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

export const getDataGacha = createSlice({
  name: 'getDataGacha',
  initialState: {
    gachas: [],
    isLoading: true,
    errorMessage: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.isLoading = true
        state.errorMessage = null
      })

      .addCase(fetchData.fulfilled, (state, action) => {
        state.isLoading = false
        state.gachas = action.payload || []
      })

      .addCase(fetchData.rejected, (state, action) => {
        state.isLoading = false
        state.errorMessage = action.payload || action.error?.message
      })
  }
})

export default getDataGacha.reducer
